'use client';
import { useEffect } from 'react';

 import Header from'@/components/common/Header';
 import Footer from'@/components/common/Footer';
 import HeroSection from'./components/HeroSection';
 import TrustStats from'./components/TrustStats';
 import HowItWorks from'./components/HowItWorks';
 import VehicleGrid from'./components/VehicleGrid';
 import SafetyFeatures from'./components/SafetyFeatures';
 import TestimonialCards from'./components/TestimonialCards';

export default function Homepage() {
  useEffect(() => {
    const reveals = document.querySelectorAll('.reveal')
    if (!reveals.length) return

    const observer = new IntersectionObserver(
      (entries) => entries.forEach(e => e.isIntersecting && e.target.classList.add('active')),
      { threshold: 0.1 }
    )
    reveals.forEach(el => observer.observe(el))

    return () => observer.disconnect()
  }, [])

  return (
    <>
      <Header />
      <main className="min-h-screen">
        <HeroSection />
        <TrustStats />
        <HowItWorks />
        <VehicleGrid />
        <SafetyFeatures />
        <TestimonialCards />
      </main>
      <Footer />
    </>
  )
}